import React from "react";
import { Button, message } from "antd";
import OrderDTO from "@/dto/order/OrderDTO";
import OrderTab from "../../../enum/OrderTab";
import { useRequest } from "ahooks";
import { setHasLogistcsInfo } from "@/services/api/order";
import { useOrderManagementStore } from "@/scenes/OrderManagement/store/OrderManagementStore";
import { collectEvent } from "@/services/dataTrack";
import DataTrackEvent from "@/services/dataTrack/enum/DataTrackEvent";
import { useGlobalStore } from "@/store/hooks";
import ShopTypeNameMap from "@/map/ShopTypeNameMap";
import OrderTabNameMap from "@/scenes/OrderManagement/map/OrderTabNameMap";

interface SetHasLogisticsInfoButtonProps {
    getSelectedOrders(): OrderDTO[];
    tab: OrderTab;
}

const SetHasLogisticsInfoButton: React.FC<SetHasLogisticsInfoButtonProps> = ({ getSelectedOrders, tab }) => {
    const orderManagementStore = useOrderManagementStore();
    const globalStore = useGlobalStore();

    const { loading, runAsync } = useRequest(
        async () => {
            const orders = getSelectedOrders();

            const shopId = orders[0].shopId;

            await setHasLogistcsInfo(orders);

            message.success("设为已有物流信息成功");

            orderManagementStore.fetchOrders(shopId, tab);

            const shop = globalStore.shopMapping.get(shopId);

            collectEvent(DataTrackEvent.SET_HAS_LOGISTICS_INFO, {
                order_count: orders.length,
                shop_id: shopId,
                shop_name: shop.name,
                shop_type: ShopTypeNameMap[shop.type],
                context: OrderTabNameMap[tab],
            });
        },
        { manual: true },
    );

    return (
        <Button type="primary" loading={loading} onClick={runAsync} className="ant-btn-warning2 mr3">
            设为已有物流信息
        </Button>
    );
};

export default React.memo(SetHasLogisticsInfoButton);
